import { Component, OnInit, Input } from '@angular/core';
import { RequestsServices } from '../../services/requests.service';
import { UserService } from '../../services/user.service';
import { ToasterService } from '../../services/toaster.service';
import { PageBase } from '../../page.base';
import { CEPServices } from '../../services/cep.service';
enum SectionType {
  TYPE_TICKET = "TYPE_TICKET",
  PAYMENT_METHOD = "PAYMENT_METHOD",
  ADDRESS = "ADDRESS",
  SEND_DATA = "SEND_DATA",
  LOADING = "LOADING",
  COUPON = "COUPON",
  SEND_EMAIL = "SEND_EMAIL",
  ERROR = "ERROR"
}

@Component({
  selector: 'cinema-ticket',
  templateUrl: './cinema-ticket.component.html',
  styleUrls: ['./cinema-ticket.component.scss'],
  providers: [ RequestsServices, UserService, CEPServices],
})
export class CinemaTicketComponent extends PageBase  implements OnInit {
  @Input() public type;
  public typeTicketList : Array<any> = [];
  public activeTypeSection: SectionType = SectionType.TYPE_TICKET;
  public typeTickedSelected: any;
  public ammountTicket: number = 1;
  public refundPolicyLink = "https://www.allya.com.br/d//documentos/politica-de-cancelamento-cinemark.pdf";
  public iAgreeRefundPolicy = false;
  public loggedUser: any = {};
  public card: any = {};
  public address: any = {};
  private timeoutRequest: any;
  private coupons: Array<any> = [];


  constructor(
    private request: RequestsServices,
    private userService: UserService,
    private toasterService: ToasterService,
    public cepService: CEPServices,) {
    super();
   }

   public ngOnInit() {
    this.getLoggedUser();
    this.getProducts();
  }

  // GENERAL
  public isShowSection(type): boolean {
    return (type === this.activeTypeSection);
  }

  public changeSection(type: SectionType) {
    this.activeTypeSection = type;
  }

  public validCard(){

    if(!this.checkCardNumber(this.card.number)){
      this.toasterService.error('Erro', `Número do cartão inválido.`, false, 4000);
      return;
    }

    if(!this.checkDate(this.card.date, "MM/YYYY")){
      this.toasterService.error('Erro', `Data do cartão inválida.`, false, 4000);
      return;
    }

    this.changeSection(SectionType.ADDRESS);
  }

  // SECTION TYPE
  public getProducts(){
    this.request.get({path: 'ticket_product', pathParam: `?filter={"where" : {"type" : "${this.type}", "active": true}}`}).then((result) => {
      this.typeTicketList = [];
      result.forEach(coupon => {
        this.getCountProductCoupons(coupon).then(res => {
          if(res.count > 0)
            this.typeTicketList.push(coupon);
        });
      });
    });
  }

  public getLoggedUser() {
    this.loggedUser = this.userService.getLoggedUser();
    this.loggedUser.emailConfirmation = this.loggedUser.email;
  }

  private getCountProductCoupons(ticket): Promise<any> {
    const filterObject: any = {
      ticketProductId: { like: ticket.id}
    };

    const createParameters = [{
      param: 'where',
      value: JSON.stringify(filterObject)
    }];

   return this.request.get({path: 'ticket_coupons', endPoint: 'ticketCouponsCount', params: createParameters});
  }

  private validSectionType() {
    this.getCountProductCoupons(this.typeTickedSelected).then(res => {
      if(this.ammountTicket > res.count){
        if(res.count == 0){
          this.toasterService.error('', `Nenhum ingresso disponível`, false, 4000);
        }else{
          this.toasterService.error('', `Quantidade de ingressos disponíveis: ${res.count}`, false, 4000);
        }
      }else{
        this.changeSection(SectionType.PAYMENT_METHOD);
      }
    });
  }

  public selectTypeTicket(type) {
    this.typeTickedSelected = type;
  }

  public isDisabledButtonTypeTicket(type) :boolean {
    if(!this.typeTickedSelected){
      return true;
    }
    return false;
  }

  public incrementAmmountTicket(value: number) {
    this.ammountTicket += value;
    if(this.ammountTicket < 1) this.ammountTicket = 1;
  }

  //SECTION REFUND POLICY
  public isDisabledButtonFinishPurchase() : boolean {
    return (!this.iAgreeRefundPolicy || !this.loggedUser.phone || !this.loggedUser.email);
  }

  public finishSale() {
    this.activeTypeSection = SectionType.LOADING;
    let ticketSale = {
      user:	{ id: this.loggedUser.customerId,  name : this.loggedUser.name, email : this.loggedUser.email, phone: this.loggedUser.phone},
      address: this.address,
      ticketProduct : this.typeTickedSelected,
      ticketAmount: this.ammountTicket,
      card: this.card
    }

    this.request.post('ticket_sales', ticketSale, '', '/sale').then(res => {
      if(this.timeoutRequest){
        clearTimeout(this.timeoutRequest);
        if(res.status == 'OK'){
          this.coupons = res.coupons;
          this.activeTypeSection = SectionType.COUPON;
        }else{
          this.activeTypeSection = SectionType.ERROR;
        }
      }
    });

    this.timeoutRequest = setTimeout( () => {
      this.activeTypeSection = SectionType.SEND_EMAIL;
      this.timeoutRequest = null;
    }, 10000);
  }

  public clearSale() {
    this.typeTickedSelected = null;
    this.ammountTicket = 1;
    this.iAgreeRefundPolicy = false;
    this.card = {};
    this.timeoutRequest = null;
    this.coupons = [];
    this.activeTypeSection = SectionType.TYPE_TICKET;
  }

  public cepChange(): void {

    if (!this.address.cep) {
      return;
    }

    const cepAux = this.address.cep.replace(/_/g, '');

    if (cepAux.length === 9) {
      this.cepService.getAddressByCep(cepAux).subscribe((place) => {
        this.address.neighborhood = place.bairro;
        this.address.city = place.localidade;
        this.address.state = place.uf;
        this.address.street = place.logradouro;
      });
    }
  }
}
